import {UseFormReturn} from 'react-hook-form';

import {DepositFormBinding} from '@dms/settings/shared';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

export const getDepositFormBinding = (
  formApi: UseFormReturn<WarehouseDirectSaleVariantsDetailFormSchemaType>
): DepositFormBinding<WarehouseDirectSaleVariantsDetailFormSchemaType> => ({
  allowDepositFieldName: 'deposit.allowDeposit',
  getFieldName: (field) => `deposit.${field}`,
  setFieldValue: (field, value, options) => formApi.setValue(`deposit.${field}`, value, options),
  setMethodAllowed: (method, isAllowed, options) =>
    formApi.setValue(`deposit.${method}.isAllowed`, isAllowed, options),
});
